module.exports = __webpack_public_path__ + "media/images/city/082-tower-of-ejer-bavnehoj-f65afd384b0c64f841cbcdf743e738d0.svg";